import {
  ItemBasic,
  ItemBasicCondensed,
  ItemHorizontalCard,
  ItemVerticalCard
} from './item';
import {
  NavigationBasicTabs,
  NavigationTabsCategorySidebar
} from './navigation';
import {
  CategoryColumn,
  CategoryVerticalList,
  CategoryVerticalCardRows,
  CategoryHorizontalCardRows
} from './category';

const displayVariantComponentMap = {
  nav: {
    BasicTabs: NavigationBasicTabs,
    TabsCategorySidebar: NavigationTabsCategorySidebar,
  },
  category: {
    VerticalList: CategoryVerticalList,
    Column: CategoryColumn,
    VerticalCardRow: CategoryVerticalCardRows,
    HorizontalCardRow: CategoryHorizontalCardRows,
  },
  item: {
    Basic: ItemBasic,
    BasicCondensed: ItemBasicCondensed,
    HorizontalCard: ItemHorizontalCard,
    VerticalCard: ItemVerticalCard,
  }
};

const variantDependencyMap = {
  navToCategory: {
    BasicTabs: ['VerticalList', 'Column', 'VerticalCardRow', 'HorizontalCardRow'],
    TabsCategorySidebar: ['VerticalList', 'Column'],
  },
  categoryToItem: {
    VerticalList: ['Basic', 'BasicCondensed', 'HorizontalCard'],
    Column: ['Basic', 'BasicCondensed'],
    VerticalCardRow: ['VerticalCard'],
    HorizontalCardRow: ['HorizontalCard']
  }
};

function computeVariants({ navDisplay, categoryDisplay, itemDisplay }) {
  const { navToCategory, categoryToItem } = variantDependencyMap;

  const allowedCategoryVariants = navToCategory[navDisplay];
  const computedCategoryDisplay = resolveVariant(allowedCategoryVariants, categoryDisplay);

  const allowedItemVariants = categoryToItem[computedCategoryDisplay];
  const computedItemDisplay = resolveVariant(allowedItemVariants, itemDisplay);

  return {
    navDisplay,
    categoryDisplay: computedCategoryDisplay,
    itemDisplay: computedItemDisplay
  }
}

function resolveVariant(options, userChoice) {
  return options.includes(userChoice) ? userChoice : randomChoice(options);
}

function randomChoice(arr) {
  return arr[Math.floor(arr.length * Math.random())];
}

export {
  computeVariants,
  displayVariantComponentMap
}